const Logo = () => {
  return <img src="/logo_alt.png" alt="Social Pro" width="150" />;
};

export default Logo;
